export default __webpack_public_path__ + "static/media/AI_Track.6344e483.svg";